import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'cc-lg-close-type',
  templateUrl: './close-type.component.html',
  styleUrls: ['./close-type.component.scss']
})
export class CloseTypeComponent implements OnInit {
  @Input() popupSettings: FormGroup;
  constructor() {}

  ngOnInit() {}
}
